// extracted by mini-css-extract-plugin
module.exports = {"hidden":"emoji-icon-button_hidden_3xL","disabledIcon":"emoji-icon-button_disabledIcon_odb"};